import { Box, List, Typography } from '@mui/material'

import React from 'react';

import IndividualCategoriesNavbar from './IndividualCategoriesNavbar';

const CategoriesNavbar = ({title, to, categories, category, setCategory, giftItems, setMoreGifts, addsIndex, setAddsIndex}) => {
  return (
    <Box sx={{display: 'flex', my:3, gap:3, alignItems:'center'}}>
        <Typography onClick={()=>setMoreGifts(giftItems)} sx={{backgroundColor:'rgba(30, 1, 86, 1)', minWidth:'fit-content', color:'rgba(255, 255, 255, 1)', display:'flex', alignItems:'center', px:1, borderRadius:'12px 0 0 12px', height:'fit-content', py:1, cursor:'pointer'}}>
           {title}
        </Typography>
        <List sx={{display:'flex', gap:2, justifyContent:'flex-start', width:'85%', overflowX:'auto','&::-webkit-scrollbar': {
          display: 'none', // Hide scrollbar in Webkit-based browsers (Chrome, Safari)
        }}}>
        {
          categories?.map((item, index)=>{
            // console.log(item)
            return <IndividualCategoriesNavbar
            key={index}
            index={index}
            item={item}
            to={to}
            setCategory={setCategory}
            category={category}
            addsIndex={addsIndex}
            setAddsIndex={setAddsIndex}
            categories={categories}
          />
          })
        }
        </List>
    </Box>
  )
}

export default CategoriesNavbar